/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useEffect } from 'react'
import { IntlProvider } from 'react-intl'

export type Locales = 'en' | 'es'

type Messages = typeof import('../../assets/I18n/en.json')

async function loadMessages(locale: Locales) {
  switch (locale) {
    case 'en':
      return import('../../assets/I18n/en.json')
    case 'es':
      return import('../../assets/I18n/es.json')
    default:
      return import('../../assets/I18n/en.json')
  }
}

function getLocale() {
  const locale = localStorage.getItem('locale')
  if (locale) {
    return locale as Locales
  } else {
    localStorage.setItem('locale', 'en')
    return 'en'
  }
}

export const IntlSelectorContext = React.createContext<{
  locale: Locales
  selectLocales: (locale: Locales) => void
} | null>(null)

function IntlSelectorProvider({
  children,
  defaultMessages,
}: {
  children: React.ReactNode
  defaultMessages?: Messages
}) {
  const [locale, setLocale] = React.useState<Locales>(getLocale())
  const [messages, setMessages] = React.useState<Messages | null>(
    defaultMessages ?? null
  )

  const selectLocales = (locale: Locales) => {
    localStorage.setItem('locale', locale)
    setLocale(locale)
  }

  useEffect(() => {
    async function load() {
      const messages = await loadMessages(locale)
      setMessages(messages.default as Messages)
    }
    void load()
  }, [locale])

  return messages ? (
    <IntlSelectorContext.Provider
      value={{
        locale,
        selectLocales,
      }}
    >
      <IntlProvider locale={locale} messages={messages}>
        {children}
      </IntlProvider>
    </IntlSelectorContext.Provider>
  ) : null
}

export default IntlSelectorProvider
